import React from 'react'
import { Button, Dropdown, Menu, PageHeader } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { removeCookie } from 'common/utils/auth'

const AdminPageHeader = (props) => {
  const {onBack, title, subTitle, extra} = props
  const extraArray = extra || []
  extraArray.push(<PageHeaderMenu key="pageHeaderMenu" props={props} />)
  
  return (
    <PageHeader
      className="site-page-header"
      onBack={onBack}
      title={title}
      subTitle={subTitle}
      extra={extraArray}
    />
  )
}

export default AdminPageHeader


const PageHeaderMenu = (props) => {

  const logout = () => {
    removeCookie()
    window.location.href = '/login'
  }
  
  const menu = (
    <Menu>
      <Menu.Item key="0">
        <a href="/admin/experiences">Experiences</a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3" onClick={logout}>Log Out</Menu.Item>
    </Menu>
  )

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      <Button icon={<MenuOutlined />} />
    </Dropdown>
  )
}
